import { render, staticRenderFns } from "./Telecom.vue?vue&type=template&id=45144dd2"
import script from "./Telecom.vue?vue&type=script&lang=js"
export * from "./Telecom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports